import React from 'react';
import { hot } from 'react-hot-loader';
import s from './Price.scss';

const Price = ({ price, soldOut = false, product = false }) => {
	const isOnSale = price.showAsOnSale || price.priceAsNumber !== price.priceBeforeDiscountAsNumber;

	if (soldOut) return <span className={[s.price, s.price__soldOut].join(' ')}><s>{ price.priceBeforeDiscount !== price.price ? price.priceBeforeDiscount : price.price }</s> { soldOut }</span>;
	// if (product) return <span className={[s.price, (isOnSale ? s.price__sale : null)].join(' ')}>{ price.price }</span>;
	return (
		<span className={s.price}>
			{ isOnSale ? <><s className={s.price_oldPrice}>{ price.priceBeforeDiscount }</s> <span className={s.price_sale}>{price.price}</span></> : price.price }
		</span>
	);
};

export default hot(module)(Price);
